import { render } from "./m-add-credit.vue?vue&type=template&id=473bb4ff"
import script from "./m-add-credit.vue?vue&type=script&lang=js"
export * from "./m-add-credit.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__